import React, { useState, useEffect } from 'react';


const WarrantyPolicyPage = () => {
  return (
    <div className="container mx-auto px-4 sm:px-6 py-8 sm:py-12">
      <div className="bg-white rounded-2xl shadow-lg p-6 md:p-10">
        <h1 className="text-4xl font-extrabold text-gray-900 mb-6 text-center">Política de Garantías</h1>
        <div className="prose max-w-none text-gray-700 leading-relaxed">

          <p>En <strong>El Ancla CR</strong> nos comprometemos con la calidad y la satisfacción de nuestros clientes. Por eso, todos los productos cuentan con una garantía limitada por defectos de fábrica, según la categoría del producto.</p>

          <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">Cobertura de Garantía</h2>
          <ul>
            <li><strong>Perfumes:</strong> Al momento de la entrega – Cobertura: Perfume en mal estado. No cubre cambios en el aroma por mal almacenamiento.</li>
            <li><strong>Tecnología y Hogar:</strong> Se especifica en factura (depende del artículo) – Cobertura: fallas de funcionamiento o fábrica. No cubre daños por mal uso, golpes o líquidos.</li>
            {/* <li><strong>Joyería:</strong> 30 días – Cobertura: cierres defectuosos, desprendimiento de piedras (sin impacto). No cubre desgaste por uso o exposición a químicos.</li> */}
          </ul>

          <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">Condiciones Generales</h2>
          <ul>
            <li>Es obligatorio presentar la factura de compra.</li>
            <li>El producto debe incluir su empaque y accesorios originales.</li>
            <li>La garantía no aplica por daños intencionales, negligencia o reparaciones ajenas a El Ancla CR.</li>
            <li>Nos reservamos el derecho de inspección para validar la cobertura.</li>
          </ul>

          <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">Cómo Solicitar la Garantía</h2>
          <ol>
            <li>Escriba a nuestro correo o WhatsApp con una breve explicación del problema y su número de factura.</li>
            <li>Le daremos seguimiento personalizado para revisar el caso.</li>
            <li>Si aplica, se procederá con reparación, cambio según disponibilidad.</li>
            <li>No se realizan reembolsos.</li>
          </ol>

          <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">Contacto</h2>
          <p>
            Correo electrónico:{' '}
            <a href="mailto:info@elancla.store" className="text-brand hover:underline">
              info@elancla.store
            </a>
          </p>
          <p>
            WhatsApp:{' '}
            <a href="https://wa.me/50689422525" target="_blank" rel="noopener noreferrer" className="text-brand hover:underline">
              +506 8942 2525
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default WarrantyPolicyPage;
